import { setAlert } from '../../alert';
import { getConfig, getFormDataConfig } from '../constants/00-base-constants';
import {
    GET_WATER_DATA_SUCCESS,
    GET_WATER_DATA_FAIL,
    POST_WATER_DATA_SUCCESS,
    POST_WATER_DATA_FAIL,
    GET_WATER_DATA_TOTALS_SUCCESS,
    GET_WATER_DATA_TOTALS_FAIL
} from '../types/04-indirect-ghg-emissions-from-products-used-by-an-organisation';
import {
    API_GET_WATER,
    API_POST_WATER,
    API_GET_WATER_TOTALS
} from '../constants/04-indirect-ghg-emissions-from-products-used-by-an-organisation';
import api from '../../../util/api';

export const postWaterData = (formData, year, company, group, facility, month) => async dispatch => {
    try {
        const { data } = await api().post(
            process.env.REACT_APP_API_URL + API_POST_WATER + `/${year}/${company}/${group}/${facility}/${month}`,
            formData,
            getFormDataConfig()
        );
        dispatch({
            type: POST_WATER_DATA_SUCCESS,
            payload: data,
        });
        dispatch(setAlert(data.detail, 'success'));
    } catch (err) {
        dispatch(setAlert(err.response.data.detail, 'error'));
        dispatch({
            type: POST_WATER_DATA_FAIL,
            payload: err.response.data.detail,
        });
    }
};

export const getWaterData = (year, facility, rowsPerPage, currentPage, month) => async dispatch => {
    try {
        const { data } = await api().get(
            process.env.REACT_APP_API_URL + API_GET_WATER + `/${year}/${facility}/${rowsPerPage}/${currentPage}/${month}`,
            getConfig()
        );
        dispatch({
            type: GET_WATER_DATA_SUCCESS,
            payload: data,
        });
        dispatch(setAlert(data.detail, 'success'));
    } catch (err) {
        dispatch(setAlert(err.response.data.detail, 'error'));
        dispatch({
            type: GET_WATER_DATA_FAIL,
            payload: err.response.data.detail,
        });
    }
};

export const getWaterDataTotals = (year, facility) => async dispatch => {
    try {
        const { data } = await api().get(
            process.env.REACT_APP_API_URL + API_GET_WATER_TOTALS + `/${year}/${facility}`,
            getConfig()
        );
        dispatch({
            type: GET_WATER_DATA_TOTALS_SUCCESS,
            payload: data,
        });
        dispatch(setAlert(data.detail, 'success'));
    } catch (err) {
        dispatch(setAlert(err.response.data.detail, 'error'));
        dispatch({
            type: GET_WATER_DATA_TOTALS_FAIL,
            payload: err.response.data.detail,
        });
    }
};